<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule"  size="small" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px"
     v-loading="dataLoading" style="width:100%;"  element-loading-text=""  element-loading-spinner="el-icon-loading"
    >
      <el-form-item label="打样产品id" prop="sampleProductId">
        <el-input v-model="dataForm.sampleProductId" placeholder="打样产品id"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="材料id" prop="materialId">
        <el-input v-model="dataForm.materialId" placeholder="材料id"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="材料编号" prop="materialNo">
        <el-input v-model="dataForm.materialNo" placeholder="材料编号"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="材料名称" prop="materialName">
        <el-input v-model="dataForm.materialName" placeholder="材料名称"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="计量值" prop="value">
        <el-input v-model="dataForm.value" placeholder="计量值"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="单位" prop="units">
        <el-input v-model="dataForm.units" placeholder="单位"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="计量百分比" prop="rate">
        <el-input v-model="dataForm.rate" placeholder="计量百分比"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="计量设备" prop="dviceNo">
        <el-input v-model="dataForm.dviceNo" placeholder="计量设备"  size="small"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()" size="small"  :disabled="dataLoading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {info,add,update} from '@/api/modules/samplerecipe'
  export default {
    data () {
      return {
        visible: false,
        dataLoading: false,
        dataForm: {
          id: 0,
          sampleProductId: '',
          materialId: '',
          materialNo: '',
          materialName: '',
          value: '',
          units: '',
          rate: '',
          dviceNo: ''
        },
        dataRule: {
          sampleProductId: [
            { required: true, message: '打样产品id不能为空', trigger: 'blur' }
          ],
          materialId: [
            { required: true, message: '材料id不能为空', trigger: 'blur' }
          ],
          materialNo: [
            { required: true, message: '材料编号不能为空', trigger: 'blur' }
          ],
          materialName: [
            { required: true, message: '材料名称不能为空', trigger: 'blur' }
          ],
          value: [
            { required: true, message: '计量值不能为空', trigger: 'blur' }
          ],
          units: [
            { required: true, message: '单位不能为空', trigger: 'blur' }
          ],
          rate: [
            { required: true, message: '计量百分比不能为空', trigger: 'blur' }
          ],
          dviceNo: [
            { required: true, message: '计量设备不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            info({id:this.dataForm.id}).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.sampleProductId = data.samplerecipe.sampleProductId
                this.dataForm.materialId = data.samplerecipe.materialId
                this.dataForm.materialNo = data.samplerecipe.materialNo
                this.dataForm.materialName = data.samplerecipe.materialName
                this.dataForm.value = data.samplerecipe.value
                this.dataForm.units = data.samplerecipe.units
                this.dataForm.rate = data.samplerecipe.rate
                this.dataForm.dviceNo = data.samplerecipe.dviceNo
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
          	this.dataLoading = true;
            var params = {
              'id': this.dataForm.id || undefined,
              'sampleProductId': this.dataForm.sampleProductId,
              'materialId': this.dataForm.materialId,
              'materialNo': this.dataForm.materialNo,
              'materialName': this.dataForm.materialName,
              'value': this.dataForm.value,
              'units': this.dataForm.units,
              'rate': this.dataForm.rate,
              'dviceNo': this.dataForm.dviceNo
            }
            var tick = !this.dataForm.id ? add(params) : update(params)
            tick.then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false;
	              	this.dataLoading = false;
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
                this.dataLoading = false;
              }
            })
          }
        })
      }
    }
  }
</script>
